const Component7 = ({ items, handleSelection, selectedCategory, selectedColor }) => {
  if (items.length !== 7) {
    return <div>Questo componente è progettato per 7 elementi!</div>;
  }

  const isOutOfStock = (item) => {
    const v = item?.out_of_stock;
    return v === 1 || v === true || v === "1" || v === "true";
  };

  const firstColumnItems = items.slice(0, 3);
  const secondColumnItem = items.slice(3, 4);
  const terzaColumnItem = items.slice(4, 7);

  const commonClass = (item) =>
    `grid-item
     ${selectedColor === item.id ? "selected-border" : ""}
     ${isOutOfStock(item) ? "disabled" : ""}
     ${item.id === "none" ? "grid-item-none" : ""}`.trim();

  const commonStyle = (item, height) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    height,
    color: "white",
    backgroundImage: `url("${item.bg}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: item?.id === "none" ? "60% auto" : "cover",
  });

  const handleClick = (item) => {
    if (isOutOfStock(item)) return;
    handleSelection(selectedCategory, item.id);
  };

  return (
    <div
      className="row m-0"
      style={{
        gap: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {firstColumnItems.map((item, index) => (
          <div
            key={`first-column-${index}`}
            onClick={() => handleClick(item)}
            className={commonClass(item)}
            style={commonStyle(item, "50%")}
          ></div>
        ))}
      </div>

      <div className="col p-0 d-flex flex-column gap-2">
        {secondColumnItem.map((item, index) => (
          <div
            key={`second-column-${index}`}
            onClick={() => handleClick(item)}
            className={commonClass(item)}
            style={commonStyle(item, "100%")}
          ></div>
        ))}
      </div>

      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {terzaColumnItem.map((item, index) => (
          <div
            key={`terza-column-${index}`}
            onClick={() => handleClick(item)}
            className={commonClass(item)}
            style={commonStyle(item, "50%")}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Component7;
